import React from "react";
import { ReactComponent as CenterDotIcon } from "assets/CenterDotIcon.svg";
import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";
import InitiativeIcon from "assets/InitiativeIcon";
import KPIIcon from "assets/KPIIcon";
import { ICardElementWithChildren } from "backend/model/model";
import ElementIcon from "../icons/ElementIcon";

export const useReportListItemStyles = makeThemedStyles(
  "ReportListItem",
  (theme) => ({
    iconContainer: {
      marginLeft: "3px",
      marginRight: "3px",
    },
    root: {
      fontSize: "12px",
      lineHeight: "1.25em",
      color: "rgba(76, 81, 87, 1)",
      gap: "2px",
      borderRadius: "5px",
      padding: "5px",
      top: "0.833em",
      right: "50%",
      display: "flex",
      flexWrap: "nowrap",
      flexDirection: "row",
      justifyContent: "flex-start",
      alignItems: "center",
      background: "rgba(225, 245, 255, 1)",
      maxHeight: "240px",
      overflow: "auto",
    },
    name: {
      width: "150px",
    },
  })
);

const ReportListItem = (props: {
  item: ICardElementWithChildren;
  onRemove?: (item: ICardElementWithChildren) => void;
}) => {
  const classes = useReportListItemStyles();
  const { item } = props;
  return (
    <>
      <div
        className={classes.root}
        onClick={() => {
          if (props.onRemove) {
            props.onRemove(item);
          }
        }}
      >
        <ElementIcon item={item} size={16} />
        <div className={classes.name}>{item.name}</div>
      </div>
    </>
  );
};

export default ReportListItem;
